import { shelfAlongWallStrip } from "building-generation/elements/caseworks/casework";
import type { Casework } from "building-types/casework/caseworkTypes";
import { RoomType } from "building-types/rooms/roomTypesEnum";
import { wallFirstIndexWithDoor } from "../walls/wall";
import type { RoomLayoutFunc, RoomLayoutGenerator } from "./roomLayout";

const shelfOppositeDoor: RoomLayoutFunc = ({ room, wallIndex }) => {
  const roomWalls = wallIndex.wallsInRoom(room);

  const casework: Casework[] = [];

  const doorWallIndex = wallFirstIndexWithDoor(roomWalls);
  if (doorWallIndex === -1) {
    return null;
  }

  const oppRoomEdgeIndex = wallIndex.wallOppositeRoomEdgeIndex(room, roomWalls, doorWallIndex);
  if (oppRoomEdgeIndex === -1) {
    return null;
  }

  const oppStrip = wallIndex.wallStripFromRoomEdgeIndex(room, oppRoomEdgeIndex);
  if (!oppStrip) {
    return null;
  }

  casework.push(shelfAlongWallStrip(oppStrip, room.level));

  return { casework };
};

const shelvesExceptDoor: RoomLayoutFunc = ({ room, wallIndex }) => {
  const casework: Casework[] = [];
  const roomWalls = wallIndex.wallsInRoom(room);

  const doorWallIndex = wallFirstIndexWithDoor(roomWalls);
  if (doorWallIndex === -1) {
    return null;
  }

  const oppRoomEdgeIndex = wallIndex.wallOppositeRoomEdgeIndex(room, roomWalls, doorWallIndex);
  if (oppRoomEdgeIndex === -1) {
    return null;
  }

  const oppStrip = wallIndex.wallStripFromRoomEdgeIndex(room, oppRoomEdgeIndex);
  const oppStrip2 = wallIndex.wallStripFromRoomEdgeIndex(room, oppRoomEdgeIndex - 1);
  const oppStrip3 = wallIndex.wallStripFromRoomEdgeIndex(room, oppRoomEdgeIndex + 1);

  if (!oppStrip || !oppStrip2 || !oppStrip3) {
    return null;
  }

  casework.push(shelfAlongWallStrip(oppStrip, room.level));
  casework.push(shelfAlongWallStrip(oppStrip2, room.level));
  casework.push(shelfAlongWallStrip(oppStrip3, room.level));

  return { casework };
};

const roomLayoutCloset: RoomLayoutGenerator[] = [
  {
    roomType: RoomType.CLOSET,
    generate: shelfOppositeDoor,
  },
  {
    roomType: RoomType.WALK_IN_CLOSET,
    generate: shelfOppositeDoor,
  },
  {
    roomType: RoomType.REACH_CLOSET,
    generate: shelfOppositeDoor,
  },
  {
    roomType: RoomType.BED_CLOSET,
    generate: shelfOppositeDoor,
  },
  {
    roomType: RoomType.PANTRY,
    generate: shelfOppositeDoor,
  },
  {
    roomType: RoomType.MASTER_CLOSET,
    generate: shelvesExceptDoor,
  },
];

export default roomLayoutCloset;
